import { isString } from 'lodash';

const fromPathToSegments = (path) => (path === '' || !isString(path) ? [] : path.split('/'));

// noinspection JSUnusedGlobalSymbols
export default fromPathToSegments;
